import { TextRange } from 'src/graphql';

export const removeOverlapFromDeletedText = (
  deletedSelections: TextRange[],
) => {
  const condensedDeletedSelections = deletedSelections
    .sort((a, b) => a.offset - b.offset)
    .reduce<TextRange[]>((acc, { offset, length }) => {
      const end = offset + length;
      const lastItem = acc[acc.length - 1];

      if (acc.length === 0 || lastItem.offset + lastItem.length < offset) {
        acc.push({ offset, length });
      } else {
        lastItem.length =
          Math.max(end, lastItem.offset + lastItem.length) - lastItem.offset;
      }
      return acc;
    }, []);

  return condensedDeletedSelections;
};
